import React, { Component } from 'react';
import { Grid, TextField, Button, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@material-ui/core';
import { validatePostalCode, WrongPostalCodeFormatText, validatePhoneNumber, WrongPhoneNumberFormatText } from '../../Common';
import { postalCodeLookup } from './PostalCodeLookup';
import { Supplier } from '../../../api/models/QuotedData';
import InfoPopover from '../../../Common/InfoPopover';
import PhoneNumberInput from '../../../Common/PhoneNumberInput';
import PostalCodeInput from '../../../Common/PostalCodeInput';

type Props = {
    update: (s: Supplier) => void,
    chosenBusinessName: string,
    updateSignUpData: (s: Supplier) => void,
    signUpData: Supplier,
}

type State = {
    supplier: Supplier,
    postalCodeFormatError: boolean,
    phoneNumberFormatError: boolean
}

class SupplierInformationForm extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            supplier: {
                suburb: "",
                name: this.props.chosenBusinessName,
                postalCode: "",
                stateCode: "",
                street: "",
                streetNumber: "",
                phoneNumber: "",
                useExternalSystem: false
            },
            postalCodeFormatError: false,
            phoneNumberFormatError: false,
        }
    }

    componentDidMount() {
        this.props.signUpData ?
            this.setState({ supplier: this.props.signUpData })
            : this.props.updateSignUpData(this.state.supplier)

    }

    render() {
        return (
            <div>
                <Grid container style={{ padding: "15px" }}>
                    <Grid item sm={2}></Grid>
                    <Grid item xs={12} sm={8}>
                        <TextField
                            value={this.props.chosenBusinessName}
                            label="Supplier Name*"
                            margin="normal"
                            variant="outlined"
                            style={{ width: '100%' }}
                            disabled={true}
                        ></TextField>
                    </Grid>

                    <Grid item sm={2}></Grid><Grid item sm={2}></Grid>
                    <Grid item xs={6} sm={3}>
                        <TextField
                            onChange={(e) => this.setState({ supplier: { ...this.state.supplier, streetNumber: e.target.value } })}
                            value={this.state.supplier.streetNumber}
                            onBlur={() => this.props.updateSignUpData(this.state.supplier)}
                            label="Street Number*"
                            margin="normal"
                            variant="outlined"
                            style={{ width: '100%' }}
                        ></TextField>
                    </Grid>

                    <Grid item xs={6} sm={5}>
                        <TextField
                            onChange={(e) => this.setState({ supplier: { ...this.state.supplier, street: e.target.value } })}
                            value={this.state.supplier.street}
                            onBlur={() => this.props.updateSignUpData(this.state.supplier)}
                            label="Street*"
                            margin="normal"
                            variant="outlined"
                            style={{ width: '100%' }}
                        ></TextField>
                    </Grid>
                    <Grid item sm={2}></Grid><Grid item sm={2}></Grid>
                    <Grid item xs={12} sm={8}>
                        <TextField
                            onChange={(e) => this.setState({ supplier: { ...this.state.supplier, suburb: e.target.value } })}
                            value={this.state.supplier.suburb}
                            onBlur={() => this.props.updateSignUpData(this.state.supplier)}
                            label="Suburb*"
                            margin="normal"
                            variant="outlined"
                            style={{ width: '100%' }}
                        ></TextField>
                    </Grid>
                    <Grid item sm={2}></Grid><Grid item sm={2}></Grid>
                    <Grid item xs={6} sm={4}>
                        <PostalCodeInput
                            onChange={(value, isValid) => {
                                this.setState({ supplier: { ...this.state.supplier, postalCode: value }, postalCodeFormatError: !isValid },
                                    () => {
                                        if (isValid) {
                                            let statel = postalCodeLookup(this.state.supplier.postalCode)
                                            this.setState({ supplier: { ...this.state.supplier, stateCode: statel } })
                                        }
                                    })
                            }}
                            value={this.state.supplier.postalCode}
                            onBlur={() => this.props.updateSignUpData(this.state.supplier)}
                            label="Postal Code*"
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4}>
                        <TextField
                            onChange={(e) => this.setState({ supplier: { ...this.state.supplier, stateCode: e.target.value } })}
                            value={this.state.supplier.stateCode}
                            onBlur={() => this.props.updateSignUpData(this.state.supplier)}
                            label="State Code*"
                            disabled={!this.state.postalCodeFormatError && this.state.supplier.stateCode !== ''}
                            margin="normal"
                            variant="outlined"
                            style={{ width: '100%' }}
                        ></TextField>
                    </Grid>
                    <Grid item sm={2}></Grid>

                    <Grid item sm={2}></Grid>
                    <Grid item xs={12} sm={8}>
                        <PhoneNumberInput
                            onChange={(value: string, isValid: boolean) => {
                                this.setState({ supplier: { ...this.state.supplier, phoneNumber: value }, phoneNumberFormatError: !isValid })
                            }}
                            onBlur={() => this.props.updateSignUpData(this.state.supplier)}
                            label="Phone Number*"
                            value={this.state.supplier.phoneNumber}
                        />
                    </Grid>
                    <Grid item sm={2}></Grid>


                    <Grid item sm={2}></Grid>
                    <Grid item xs={12} sm={8}>
                        <FormControl component="fieldset" style={{ marginTop: '10px' }}>
                            <FormLabel component="legend">Would you like to connect your external system to the QMO?
                            <InfoPopover>
                                    If you have a system for keeping your stocks we will contact you and integrate it with QMO! Otherwise you can manage your offer using QMO!
                            </InfoPopover>
                                <br /><small>(You can change it later)</small></FormLabel>
                            <RadioGroup
                                style={{ padding: '8px' }}
                                aria-label="sup-sys-check"
                                name="sup-sys-check"
                                value={this.state.supplier.useExternalSystem}
                                onChange={(e) => { this.setState({ supplier: { ...this.state.supplier, useExternalSystem: e.target.value === "true" } }) }}>
                                <FormControlLabel value={true} control={<Radio />} label="Yes, I want to use my system" />
                                <FormControlLabel value={false} control={<Radio />} label="No, I will use the default QMO Supply System." />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item sm={2}></Grid>


                    <Grid item sm={3} md={4}></Grid>
                    <Grid item xs={12} sm={6} md={4} style={{ paddingTop: '15px', textAlign: 'center' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={this.state.phoneNumberFormatError || this.state.postalCodeFormatError
                                || this.state.supplier.name === ""
                                || this.state.supplier.phoneNumber === ""
                                || this.state.supplier.postalCode === ""
                                || this.state.supplier.stateCode === ""
                                || this.state.supplier.street === ""
                                || this.state.supplier.streetNumber === ""
                                || this.state.supplier.suburb === ""}
                            onClick={() => { this.props.update({ ...this.state.supplier, name: this.props.chosenBusinessName }) }}>Next</Button>
                    </Grid>
                    <Grid item sm={3} md={4}></Grid>

                </Grid>
            </div>
        );
    }
}

export default SupplierInformationForm;